/* Drives the overflow affordances on horizontally scrolling rows: the edge
   fade (assets/component-scroll-hint.css) and the chevron buttons
   (assets/component-quick-filters.css).

   The point is that both are MEASURED, not assumed: they appear only where
   the content actually overflows, and flip to the other edge when you reach
   the end. That is what makes them read as "there is more" rather than as
   decoration - a permanent fade looks identical whether or not the row
   scrolls, so it tells the user nothing.

   Loaded from the product card snippet and the quick filter section, so the
   tag repeats once per card - the guard below makes every copy after the
   first a no-op. */
(function () {
  if (window.__scrollHintReady) return;
  window.__scrollHintReady = true;

  var SELECTOR = '.qf__row, .mattress-card__chips';

  function update(el) {
    var max = el.scrollWidth - el.clientWidth;
    var overflowing = max > 2;
    el.classList.toggle('has-overflow', overflowing);
    el.classList.toggle('at-start', el.scrollLeft <= 1);
    el.classList.toggle('at-end', !overflowing || el.scrollLeft >= max - 1);
  }

  function init(el) {
    if (el.dataset.scrollHint) return;
    el.dataset.scrollHint = '1';
    el.classList.add('scroll-hint');
    el.addEventListener('scroll', function () { update(el); }, { passive: true });
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () { update(el); }).observe(el);
    }
    update(el);
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  var queued = false;
  function scanSoon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  /* Chevrons. Delegated so buttons added by a later filter re-render work
     without re-binding. Scrolls by most of a screenful but keeps a sliver of
     the previous pill in view, so the user can see where they came from. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.qf__nav') : null;
    if (!button) return;
    var row = button.parentElement.querySelector('.qf__row');
    if (!row) return;
    event.preventDefault();
    var step = Math.max(120, Math.round(row.clientWidth * 0.8));
    row.scrollBy({
      left: button.classList.contains('qf__nav--prev') ? -step : step,
      behavior: 'smooth'
    });
  });

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  window.addEventListener('resize', scanSoon, { passive: true });

  /* The grid is re-rendered in place when a filter changes, so new chip
     rows appear without a page load. */
  if (typeof MutationObserver === 'function') {
    new MutationObserver(scanSoon).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
